// ---------------------------------------------------------------------------
// management-view-overview-api
//
// Frontend service wrapper for the Overview tab's highlights endpoint
// (US1 / PRODOPSAI-401). One round-trip per filter change returns the ranked
// highlights list plus the server-formatted `periodLabel`.
//
// Per CLAUDE.md, the `api` wrapper prepends `/api` to every endpoint, so the
// strings passed in must NOT include the `/api` prefix.
//
// Mirrors the shape of `management-view-quality-control-api.ts` (Phase 1) so
// the two Management View tab data flows stay structurally consistent.
// ---------------------------------------------------------------------------

import { api } from '@/lib/api';
import { buildManagementViewParams, type IManagementViewQuery } from '@/lib/management-view-query';
import type {
  IApiResponse,
  IOverviewHighlightsResponse,
} from '@skystone/shared';

export type IOverviewHighlightsQuery = IManagementViewQuery;

export const managementViewOverviewApi = {
  /**
   * `GET /api/management-view/overview/highlights` — returns the ranked Overview
   * highlights list (capped at 6) and a server-formatted `periodLabel` for the
   * active scope/window/cadence filters. Used by `OverviewTab` (US4) to feed
   * `HighlightsCard`.
   */
  getHighlights: async (
    query: IOverviewHighlightsQuery,
  ): Promise<IOverviewHighlightsResponse> => {
    const params = buildManagementViewParams(query);
    const result = await api.get<IApiResponse<IOverviewHighlightsResponse>>(
      `/management-view/overview/highlights?${params.toString()}`,
    );
    return result.data;
  },
};
